// extracted by mini-css-extract-plugin
export default {"typedLine":"TypingText_typedLine__9UeZY","dynamic":"TypingText_dynamic__8+QVh","cursor":"TypingText_cursor__4TO-B","blink":"TypingText_blink__MOONN"};